import { AppInit, INavLink, ConsentManager} from '@hwm/ui-lib';
import { styleConstants } from '@styles/constants';
import { lazy, useState } from 'react';
import 'uplot/dist/uPlot.min.css';
import store from './core/store/store';
import { environment } from './environment';
import './index.css';
import theme from './styles/theme';
import { AppPaths } from '@core/routes/Routes';
import { userProfileReducer } from '@core/store/library-stores/user-profile';
import { UserDetails } from '@shared/components/UserDetails';
import { MainMenu } from '@shared/components/MainMenu';
import { DGA_APP_NAME } from '@shared/components/MainMenu';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { Provider } from 'react-redux';
import { actionInterceptor } from '@core/store/middleware/actionsInterceptorMiddleware';
import { Trans } from '@lingui/macro';

const LazyLayout = lazy(() => import('./shared/components/Layout'));
const consentTexts = {
    banner: {
        description: <Trans>We use cookies to improve your experience. You can accept all cookies, reject non-essential cookies, or manage your preferences.</Trans>,
        acceptAll: <Trans>Accept All</Trans>,
        rejectAll: <Trans>Reject All</Trans>,
        preferences: <Trans>Preferences</Trans>
    },
    modal: {
        title: <Trans>Cookie Preferences</Trans>,
        analyticsLabel: <Trans>Analytics (Microsoft Clarity)</Trans>,
        analyticsDescription: <Trans>Allows us to understand how visitors use our site to improve UX. No personal data is sold or shared outside our organization.</Trans>,
        save: <Trans>Save Preferences</Trans>,
        cancel: <Trans>Cancel</Trans>
    }
};

// Define consent manager translations
export const AppComponent: React.FC = () => {
    const [links, setLinks] = useState<INavLink[]>([]);
    return (
        <>
            <I18nProvider i18n={i18n as any} forceRenderOnLocaleChange={false}>
                <ConsentManager clarityId={environment.clarityId} texts={consentTexts}>
                    <Provider store={store}>
                        {AppInit({
                            LazyLayout: LazyLayout,
                            actionInterceptor: actionInterceptor as any,
                            applicationPaths: AppPaths,
                            styleConstants: styleConstants,
                            theme: theme,
                            additionalConfig: {
                                authority: environment.authority,
                                clientId: environment.clientId,
                                scope: environment.scope,
                                silentLoginTimeout: environment.silentLoginTimeout,
                            },
                            initialLayoutProps: {
                                appName: DGA_APP_NAME,
                                customButtons: [<UserDetails />, <MainMenu links={links} setLinks={setLinks} />],
                                links: links,
                                className: 'hide-logout',
                                sessionConfig: {
                                    sessionCookieDomain: environment.sessionCookieDomain,
                                    sessionCookieIsSecure: environment.sessionCookieSecure,
                                    sessionIdleTimeout: environment.sessionCookieIdleTimeout,
                                },
                                accountHierarchyReset: false,
                            },
                            redirectEmptyUrl: '/dashboard',
                            setOidcUser: (d) => store.dispatch(userProfileReducer.slice.actions.setOidcUser(d)),
                        })}
                    </Provider>
                </ConsentManager>
            </I18nProvider>

        </>
    );
};
